module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/KnightFight.de08c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/KnightFight.jpg
// module id = B2b/
// module chunks = 0